import React from "react"
import OverallAgreementsModal from "organisms/top/OverallAgreementsModal"

const TopAgreementsModals = () => {
  const modalParam = {
    title: "TopAgreements.Title",
    textTop: "TopAgreements.TextTop",
    linkText: "TopAgreements.LinkText",
    linkUrl: "TopAgreements.LinkUrl",
    textMid1: "TopAgreements.TextMid1",
    textCheckbox: "TopAgreements.TextCheckbox",
    textMid2: "TopAgreements.TextMid2",
    okButton: "TopAgreements.OkButton",
  }

  return (
    <OverallAgreementsModal
      {...{
        value: "CheckAgreement",
        modalParam,
      }}
    />
  )
}

export default TopAgreementsModals
